import React from "react";
import { useState, useEffect } from "react";
import { Box, useMediaQuery, IconButton, useTheme, Tooltip } from "@mui/material";
import { MenuOutlined } from "@mui/icons-material";
import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar";

const Layout = ({
  showModeratorBoard,
  showAdminBoard,
  showMIBoard,
  showReviewerBoard,
  showChiefBoard,
  currentUser,
  logOut,
}) => {
  const theme = useTheme();
  const isNonMobile = useMediaQuery("(min-width: 890px)");
  const [isNavbarOpen, setIsNavbarOpen] = useState(true);

  useEffect(() => {
    if (!isNonMobile) {
      setIsNavbarOpen(false);
    }
  }, [isNonMobile]);

  return (
    <Box display={isNonMobile ? "flex" : "block"} width="100%" height="100%">
      <Navbar
        showAdminBoard={showAdminBoard}
        showMIBoard={showMIBoard}
        showReviewerBoard={showReviewerBoard}
        showChiefBoard={showChiefBoard}
        showModeratorBoard={showModeratorBoard}
        currentUser={currentUser}
        logOut={logOut}
        isNavbarOpen={isNavbarOpen}
        setIsNavbarOpen={setIsNavbarOpen}
        isNonMobile={isNonMobile}
        drawerWidth="250px"
      />
      {!isNavbarOpen && (
        <Tooltip title="Open menu">
          <IconButton
            onClick={() => setIsNavbarOpen(!isNavbarOpen)}
            color="inherit"
            sx={{
              position: "fixed",
              top: "0.9rem",
              left: "0.9rem",
              zIndex: 1200,
              backgroundColor: theme.palette.background.alt,
              boxShadow:
                theme.palette.mode === "dark"
                  ? "0 4px 14px rgba(2, 3, 12, 0.4)"
                  : "0 4px 14px rgba(24, 29, 69, 0.15)",
              "&:hover": {
                backgroundColor: theme.palette.background.alt,
              },
            }}
          >
            <MenuOutlined />
          </IconButton>
        </Tooltip>
      )}
      <Box flexGrow={1} sx={{ minWidth: 0 }}>
        <Outlet />
      </Box>
    </Box>
  );
};

export default Layout;
